<template>
    <div class="container-fluid">
        <slot :data="slotData"></slot>
    </div>
</template>

<script>
    export default {
        props:{
            assessments:{
                required:true,
                default(){
                    return []
                }
            }
        },
        data() {
            return {}
        },
        computed:{
            slotData(){
                return {
                    assessments: this.assessments
                }
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/index/AssessmentIndexPage.vue